import { Reveal } from "./Reveal";

export const Manifesto = () => (
  <section id="about" data-testid="about-section" className="bg-cream text-ink py-28 md:py-40">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <div className="grid md:grid-cols-2 gap-16 items-start">
        <Reveal>
          <p className="eyebrow text-royal">The Manifesto</p>
          <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-tight mt-6">
            Actionable wisdom for a <span className="italic text-royal">thriving tomorrow</span>.
          </h2>
          <p className="mt-8 text-ink/70 text-base leading-relaxed">
            Rachelle Cooper Kulkarni MSc is a visionary future-maker, alchemist and systems thinker,
            driven by a passion to create the future we need collectively. Her career spans multiple
            sectors globally, with a focus on energy and sustainability. This experience illuminated
            her one unwavering purpose: to deliver change that truly matters.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="relative max-w-sm md:ml-auto">
            <div className="absolute inset-0 translate-x-4 translate-y-4 border border-gold" aria-hidden="true" />
            <img src="/photos/rachelle-speaking-2.webp" alt="Rachelle Cooper Kulkarni speaking on stage"
              data-testid="about-portrait" className="relative w-full aspect-[3/4] object-cover" />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
